import { createSlice } from "@reduxjs/toolkit";


const itemGradeCountSettingSlice = createSlice({
    name: "itemGradeCountSetting",
    initialState: {
        itemData: [],
        gradeData: [],
        countData: []
    },
    reducers: {
        setItemData: (state, action) => {
            state.itemData = action.payload;
        },
        setGradeData: (state, action) => {
            state.gradeData = action.payload;
        },
        setCountData: (state, action) => {
            state.countData = action.payload;
        },
    }
});

export const {
    setItemData, setGradeData, setCountData
} = itemGradeCountSettingSlice.actions;

export default itemGradeCountSettingSlice.reducer;